export const PATHS = {
  HOME: '/',
  REPO: '/repo/:author/:name',
};
